module.exports = __webpack_public_path__ + "800ad4cf8d8c4cfb4a6aeb7393e49651.MP3";